/**
 * LandingWhyChoose — "Why teams pick ReadyRoomOps" section.
 *
 * Light surface, three feature cards. Each card has a soft-tile
 * icon (orange / green / black for variety within the brand
 * palette), a bold title, and a tight body. Mirrors NoRework's
 * "Why crews choose NoRework" section structure.
 */

import { type ReactNode }                              from 'react'
import { Clock, ShieldCheck, BadgeDollarSign }         from 'lucide-react'
import {
  WHY_HEADLINE,
  WHY_SUBHEAD,
  WHY_CARDS,
  type WhyCard,
}                                                      from './landingCopy'

const ICON_BY_NAME: Record<WhyCard['icon'], typeof Clock> = {
  Clock,
  ShieldCheck,
  BadgeDollarSign,
}

export function LandingWhyChoose(): ReactNode {
  return (
    <section className="landing-section" aria-labelledby="why-h">
      <div className="landing-section__inner">
        <h2 id="why-h" className="landing-section__eyebrow">{WHY_HEADLINE}</h2>
        <p className="landing-section__lede">{WHY_SUBHEAD}</p>

        <div className="why-grid">
          {WHY_CARDS.map((card) => {
            const Icon = ICON_BY_NAME[card.icon]
            return (
              <article key={card.title} className="why-card">
                <span className={`icon-tile icon-tile--${card.tone}`}>
                  <Icon size={24} strokeWidth={2} />
                </span>
                <h3>{card.title}</h3>
                <p>{card.body}</p>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}
